import React, {useEffect, useMemo, useState} from "react";
import {getIndividualSetting} from "../../api/user/UserAccountService";
import {initHeaderOrders, simmsColumnsToJsGridHeaders} from "../commonmethod/CommonMethod";
import DetailLinkedDataGrid from "./DetailLinkedDataGrid";
import DetailLinkedPagination from "./DetailLinkedPagination";
import "./detailLinkedList.css";

/**
 * 상세 화면 연결 목록(구매·라이선스·계약 등) — 컴팩트 열 정렬 그리드
 */
function DetailLinkedListView({
    headerDefinition,
    settingKey,
    newData,
    onPageChange,
    onRowClick,
    children,
    className = "",
    readOnly = false,
}) {
    const [header, setHeader] = useState({order: headerDefinition, exclude: []});

    useEffect(() => {
        if (!settingKey) {
            setHeader({order: headerDefinition, exclude: []});
            return;
        }
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, headerDefinition, setHeader, [], () => {}, () => {}, settingKey);
        });
    }, [headerDefinition, settingKey]);

    const columns = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const rows = newData?.content ?? [];
    const pageable = newData?.pageable ?? {};
    const interactive = !readOnly && typeof onRowClick === "function";

    return (
        <div
            className={`detail-view-tab-panel detail-linked-list-root asset-detail-linked-list flex min-h-0 min-w-0 flex-1 flex-col w-full h-full ${className}`.trim()}
        >
            {children ? <div className="asset-detail-linked-toolbar shrink-0">{children}</div> : null}

            <div className="asset-detail-linked-body">
                {rows.length === 0 ? (
                    <div className="asset-linked-grid-empty" role="status">
                        조회된 데이터가 없습니다.
                    </div>
                ) : (
                    <div className="detail-linked-list-panel asset-detail-panel">
                        <div className="detail-linked-data-grid-scroll">
                            <DetailLinkedDataGrid
                                rows={rows}
                                columns={columns}
                                interactive={interactive}
                                onRowClick={onRowClick}
                            />
                        </div>
                    </div>
                )}
                <DetailLinkedPagination pageable={pageable} onPageChange={onPageChange} />
            </div>
        </div>
    );
}

export default DetailLinkedListView;
